import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX token map API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const DEX_TOKEN_MAP_API_ENDPOINTS = {
  getTokenMap: {
    generated: 'apiControllerGetBindings',
    method: 'get',
    path: '/loan/map',
  },
  bindTokenMap: {
    generated: 'apiControllerMapBind',
    method: 'post',
    path: '/loan/map/bind',
  },
  unbindTokenMap: {
    generated: 'apiControllerMapUnbind',
    method: 'post',
    path: '/loan/map/unbind',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexTokenMapEndpointName = keyof typeof DEX_TOKEN_MAP_API_ENDPOINTS;
